import script from "./LatestNews.vue?vue&type=script&setup=true&lang=js"
export * from "./LatestNews.vue?vue&type=script&setup=true&lang=js"

import "./LatestNews.vue?vue&type=style&index=0&id=20ce1af0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ce1af0"]])

export default __exports__